import axios from "../../utils/axios";

export async function getJobs() {
  const response = await axios.get(`/jobs`);
  return response.data;
}

export async function postJob(data) {
  const response = await axios.post(`/jobs`, data);
  return response.data;
}

export async function deletejob(id) {
  const response = await axios.delete(`/jobs/${id}`);

  return response.data;
}
